import { NgModule } from "@angular/core"
import { RatingStars } from "./rating-stars.component"
import { CommonModule } from "@angular/common"
import { BsDropdownModule } from "ngx-bootstrap/dropdown"

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule
  ],
  declarations: [RatingStars],
  exports: [RatingStars]
})
export class RatingStarsModule {}
